import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router-dom';
import { Dashboard } from './components/Dashboard';
import { ErrorScreen } from './components/Error/ErrorScreen';
import { LandingPage } from './components/LandingPage';
import PlayerSelect from './components/PlayerSelect';
import { ResortDeepLink } from './components/Resort/deepLink/ResortDeepLink';
import { RestartRequired } from './components/RestartRequired';
import { CheckLanguageSetup } from './components/shared/CheckLanguageSetup';
import { Startup } from './components/Startup';
import Walkthrough from './components/Walkthrough';
import { RootState } from './features';
import i18n from './i18n';
import { fontFamily } from './lib/font-family';
import { sendPageView } from './lib/google-analytics';

const displayDebugInfo = process.env.REACT_APP_DEBUG_OPTION === 'true';

export const Routing: React.FC = () => {
  const history = useHistory();
  const { language, causeServerError } = useSelector((state: RootState) => state.user);
  useEffect(() => {
    const unregister = history.listen((location: unknown) => {
      const { pathname, search } = location as any;
      sendPageView(`${pathname}${search}`);
      document.title = i18n.t('translation:service_name');
    });
    return () => {
      unregister();
    };
  }, [history]);

  if (causeServerError) {
    return <ErrorScreen />;
  }

  return (
    <div
      className={css`
        width: 100%;
        height: 100%;
        font-family: ${fontFamily(language || 'en-US')};
        position: relative;
        overflow: auto;
      `}
    >
      <Switch>
        <Route exact={true} path="/" component={Startup} />
        <Route path="/restart-required" component={RestartRequired} />
        <CheckLanguageSetup>
          <Route path="/lp" component={LandingPage} />
          <Route path="/player-select" component={PlayerSelect} />
          <Route path="/deep-link" component={ResortDeepLink} />
          <Route path="/players" component={Dashboard} />
          <Route path="/walkthrough" component={Walkthrough} />
        </CheckLanguageSetup>
      </Switch>

      {/* Display only when dd1 env */}
      {displayDebugInfo && (
        <>
          <div
            style={{
              position: 'fixed',
              left: 0,
              bottom: 0,
              fontSize: '12px',
              paddingLeft: 'calc(4px + env(safe-area-inset-left))',
              paddingBottom: 'calc(4px + env(safe-area-inset-bottom))',
              zIndex: 1000
            }}
          >
            <div style={{ color: 'gray' }}>{navigator.language}</div>
            <div>{language}</div>
          </div>

          <span
            style={{
              position: 'fixed',
              right: 0,
              bottom: 0,
              fontSize: '12px',
              paddingRight: 'calc(4px + env(safe-area-inset-right))',
              paddingBottom: 'calc(4px + env(safe-area-inset-bottom))',
              zIndex: 1000
            }}
          >
            {process.env.REACT_APP_VERSION}
          </span>
        </>
      )}
    </div>
  );
};
